<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          style="cursor:pointer"
        >view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="row">
            <div class="col-sm-12 print-media">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
            </div>
          </div>
          <h3 class="text-blue mt-3">{{trainingDetails.title}}</h3>

          <div class="row mt-5">
            <div class="col-lg-6">
              <h4 class="text-blue">Training Brief Information</h4>
            </div>
            <div class="col-lg-6">
            
              <button
                class="btn btn-primary text-uppercase btn-report float-right ml-3 "
                 @click="PrintTrainingDetails"
              >Print Training Details</button>
                <router-link
                :to="{ path: '/dashboard/CountryRepresentative/analysisIndvidualCountry_represent'}"
                class="btn btn-primary text-uppercase btn-report float-right"
              >Individual Analysis</router-link>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Country</label> Pakistan
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Province</label> Punjab
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">City</label> Lahore
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Advisor</label> Mr.A
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Program Officer</label> Mr..
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Sub Program / Project</label> PACT
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Donor</label> European Union
            </div>

            <div class="col-sm-8">
              <label class="mr-2 font-weight-bold">Trainers</label> Mr.A, Mr.B, Mr.C
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">Start Date</label> 12/12/2020
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">End Date</label> 17/12/2020
            </div>

            <div class="col-sm-4">
              <label class="mr-2 font-weight-bold">No. of Days</label> 5
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-sm-7">
              <h4 class="text-blue">Attendees Information</h4>
            </div>
            <div class="col-sm-5">
             <a @click="$bvModal.show('addNewPerson')"
                class="btn btn-primary text-uppercase btn-report float-right ml-3 text-white"
              >Add</a>
            </div>
             <div class="table-responsive pl-3">
              <table class="table table-borderless mt-3">
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th>CNIC</th>
                    <th>Designation</th>
                    <th>Department</th>
                    <th>Email</th>
                    <th>Number</th>
                    <th>Attendance</th>
                  </tr>
                </thead>
              <!-- </table>
              <h5 class="text-blue">Trainees</h5>
              <table class="table table-borderless mt-3">
                <tbody> -->
                  <h5 class="text-blue pl-2">Trainees</h5>
                  <tr>
                    <td>1</td>
                    <td>Mohsin Abid</td>
                    <td>1235</td>
                    <td>SHO</td>
                    <td>KPK Police</td>
                    <td>john@example.com</td>
                    <td>+1234567</td>
                    <td>Present</td>
                  </tr>

                  <tr>
                    <td>2</td>
                    <td>Mohsin Abid</td>
                    <td>1235</td>
                    <td>SHO</td>
                    <td>KPK Police</td>
                    <td>john@example.com</td>
                    <td>+1234567</td>
                    <td>Present</td>
                  </tr>

                  <tr>
                    <td>3</td>
                    <td>Mohsin Abid</td>
                    <td>1235</td>
                    <td>SHO</td>
                    <td>KPK Police</td>
                    <td>john@example.com</td>
                    <td>+1234567</td>
                    <td>Present</td>
                  </tr>
                </tbody>
              </table>
              <h5 class="text-blue">UNODC Staff & Facilitators</h5>
              <table class="table table-borderless mt-3">
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Amanullah</td>
                    <td>1235</td>
                    <td>M&E</td>
                    <td>KPK Police</td>
                    <td>john@example.com</td>
                    <td>+1234567</td>
                    <td>Present</td>
                  </tr>

                  <tr>
                    <td>2</td>
                    <td>Umair</td>
                    <td>1235</td>
                    <td>M&E</td>
                    <td>KPK Police</td>
                    <td>john@example.com</td>
                    <td>+1234567</td>
                    <td>Present</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
     <!--addNewPerson-->
    <b-modal id="addNewPerson" hide-footer hide-header>
      <form @submit.prevent="addProvince">
        <div style="padding: 40px">
          <h5 class="text-center">Add New (Person)</h5>
          <div class="d-block mt-4">
            <div class="form-group">
              <label class="font-weight-bold">Name </label>
              <input
                type="text"
                class="form-control"
                placeholder="Enter Name"
              />
            </div>
            <div class="form-group">
              <label class="font-weight-bold">CNIC</label>
             <input
                type="text"
                class="form-control"
                placeholder="Enter CNIC"
              />
            </div>
             <div class="form-group">
              <label class="font-weight-bold">Designation</label>
             <input
                type="text"
                class="form-control"
                placeholder="Enter Designation"
              />
            </div>
             <div class="form-group">
              <label class="font-weight-bold">Department</label>
             <input
                type="text"
                class="form-control"
                placeholder="Enter Department"
              />
            </div>
             <div class="form-group">
              <label class="font-weight-bold">Email</label>
             <input
                type="text"
                class="form-control"
                placeholder="Enter Email"
              />
            </div>
             <div class="form-group">
              <label class="font-weight-bold">Phone Number</label>
             <input
                type="text"
                class="form-control"
                placeholder="Enter Phone Number"
              />
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <b-button type="submit" class="mt-3 mr-1 modal-btn" variant="primary">Add</b-button>
            <b-button
              variant="outline-primary"
              class="mt-3 ml-1 modal-btn"
              @click="$bvModal.hide('addNewPerson')"
            >Cancel</b-button>
          </div>
        </div>
      </form>
    </b-modal>
  </div>
</template>


<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

export default {
  data: () => ({
    isActve1: 1,
    trainingCode: "",
    trainingDetails: [],
    trainingId: "",
    alltrainers: [],
    allTrainees: [],
    doners: [],
    isSidebar: false,
    colorx: "warning"
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  },
  created() {},
  methods: {
    showTrainers: function showTrainers(tId) {
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/single/training/trainer/get/" +
            tId
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.alltrainers = response.data;
        });
    },
    showTrainees: function showTrainees(tId) {
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/single/training/traineedetails/report/get/" +
            tId
        ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.allTrainees = response.data.trainees;
        });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
   PrintTrainingDetails: function() {
      window.print();
    }
  },
  mounted() {
    this.trainingCode = this.$route.query.trainingId;
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode
      ,{
              headers:{
                Authorization:localStorage.getItem("token"),
              }
            }
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data && response.data.training) {
          this.trainingDetails = response.data.training;
          this.showTrainers(response.data.training.id);
          this.showTrainees(response.data.training.id);
        }
        if (response.data && response.data.doner) {
          this.doners = response.data.doner;
        }
      });
  }
};
</script>

<style scoped>
.text-blue {
  color: #00a4ea;
}
.btn-report {
  background-color: #6488d2 !important;
  border-radius: 0px !important;
  padding: 3px 30px !important;
}
.table th,
.table td {
  width: 10%;
}
@media print{
  #page-content-wrapper {
    overflow: scroll !important;
    height: auto !important;
}
 .btn-report{
   display:none
 }
 .print-media{
   display:none;
 }
}
</style>
